import React from 'react';
import './JoinATSection.scss';

const JoinATSection = ({ onImReady }) => {
  return (
    <section id="join-at" className="join-at-section">
      <h2 className="join-at-section__title scroll-animate fade-up stagger-1">
        Connect with over <br /> 25k athletic trainers now!
      </h2>
      <button className="join-at-section__button scroll-animate fade-up-bold stagger-2" onClick={onImReady}>
        Get Started
      </button>
    </section>
  );
};

export default JoinATSection;
